import { useLayoutEffect, useState } from 'react';

import { isIOS } from 'react-device-detect';
import { TValueOf } from '@skillarea/lib-shared';

export const EResolutions = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
} as const;

export type TResolution = TValueOf<typeof EResolutions>;

const breakpoints: Record<TResolution, string> = {
  mobile: '(max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 1023px)',
  desktop: '(min-width: 1024px)',
} as const;

export const useAdaptive = () => {
  const [resolution, setResolution] = useState<TResolution>();

  const handleResize = () => {
    setResolution(
      Object.values(EResolutions).find(
        (resolution) => window.matchMedia(breakpoints[resolution]).matches,
      ) || EResolutions.mobile,
    );
  };

  useLayoutEffect(() => {
    const timeoutId = setTimeout(() => {
      handleResize();
      window.addEventListener('resize', handleResize);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile: resolution === EResolutions.mobile,
    isTablet: resolution === EResolutions.tablet,
    isDesktop: resolution === EResolutions.desktop,
    isIOS,
  };
};
